export const stable = {
  name: 'Haavakannu Tall',
  phone: '+372 5563 0064',
  email: 'info@haavakannu.ee',
  address: 'Põllu-Keskuta, Haavakannu, 74628 Harju maakond, Estonia',
  mapUrl: 'https://maps.app.goo.gl/yjevy83mEfuKRRYRA',
  /** € off per rider for rides November – March. */
  winterDiscount: 5,
  /**
   * Your SimplyBook.me booking page, e.g. 'https://haavakannu.simplybook.it'.
   * Leave empty until the account is set up — the booking window then shows phone and email instead.
   */
  simplyBookUrl: '',
};
